import React, { Component } from 'react'
import CommentItem from './CommentItem'

import './style.css';



export class Comment extends Component {
   render() {
      return (
         <div className='coments_component _container'>
            <div className="title_text--comments">What the People Thinks About Interno</div>
            <div className="comments_block">
               {this.props.comments.map(el => (
                  <CommentItem key={el.id} item={el} />
               ))}
            </div>
         </div>
      )
   }
}

export default Comment
